import { render, staticRenderFns } from "./styles.vue?vue&type=template&id=c3c12d9a&scoped=true&"
import script from "./styles.vue?vue&type=script&lang=js&"
export * from "./styles.vue?vue&type=script&lang=js&"
import style0 from "./styles.vue?vue&type=style&index=0&id=c3c12d9a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c12d9a",
  null
  
)

export default component.exports